/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICartIconViewProps } from '@msdyn365-commerce-modules/cart/src/modules/cart-icon/./cart-icon';
import { IFlyoutCartLineItemViewProps } from '@msdyn365-commerce-modules/cart/src/modules/cart-icon/./components/flyout-cart-line-items';
import { ICartIconProps } from '../definition-extensions/cart-icon.ext.props.autogenerated';
import { RichTextComponent } from '@msdyn365-commerce/core-internal';

const _renderCartlines = (
    cartLines: IFlyoutCartLineItemViewProps[] | undefined,
    props: ICartIconViewProps & ICartIconProps<{}>
): JSX.Element[] | null => {
    if (!cartLines) {
        props.context.telemetry.error('Cartlines content is empty, module wont render');
        return null;
    }
    return cartLines.map((cartLine, index) => {
        return (
            <Node {...props.miniCartItemWrapper} key={index}>
                {cartLine.cartline}
                {cartLine.storeLocation}
                {cartLine.remove}
            </Node>
        );
    });
};

const CartIconView: React.FC<ICartIconViewProps & ICartIconProps<{}>> = (props: ICartIconViewProps & ICartIconProps<{}>) => (
    <Node {...props.miniCartWrapper} {...props.renderModuleAttributes(props)}>
        {props.cartIcon}
        {props.FlyoutContainer ? (
            <Node {...props.FlyoutContainer}>
                {props.flyoutTitle}
                <Node {...props.CartlinesWrapper}>{_renderCartlines(props.cartlines, props)}</Node>
                {props.cartlines ? (
                    <div className='filled-cart'>
                        {props.totalPrice}
                        <div className='minicart-checkoutbtn-wrapper'>
                            {!props.context.request.user.isAuthenticated ? props.checkoutAsSignInUserButton : (
                                <>
                                    <a href="./checkout" title={props.resources.checkoutButtonLoggedInTitle} data-exp-event-id="Cart Page.Cart.Checkout.click" className="ms-cart-icon__btn-checkout msc-btn disabled">{props.resources.checkoutButtonLoggedInTitle}</a>
                                </>
                            )
                            }
                            {props.goToCartButton}
                        </div>
                    </div>
                ) : (
                    <div className='empty-cart'>
                        {props.totalPrice}
                        <div className='minicart-checkoutbtn-wrapper'>
                            <div className='shopping-item-text'>
                                {props.resources.noItems}
                                {props.config.continueShoppingLink?.linkText && (
                                    <a className='terms-condition-links' href={props.config.continueShoppingLink?.linkUrl.destinationUrl}>
                                        {<RichTextComponent text={props.config.continueShoppingLink?.linkText} />}
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </Node>
        ) : (
            false
        )}
    </Node>
);

export default CartIconView;
